// Package imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Mui imports
import { styled } from "@mui/system";

// App components import
import AppNavBar from "../appComponents/navbar/AppNavBar";
import AppVideoPlayer from "../appComponents/video/AppVideoPlayer";

// Redux imports
import { getConfig } from "../store/thunks/config.thunk";
import { AppDispatch } from "../store/store";

// @ts-ignore
import vid from "../components/assets/background.mp4";

// import layout components
import Greeting from "../components/layouts/Greeting";
import { getImages } from "../helpers/Image.helper";

// type imports
import { IRootState } from "../models/general.model";

// Styling for the wrapper
const StyledBackgroundVideoWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  backgroundColor: "#eeeeeec9",
  opacity: 0.4,
  zIndex: 0,
}));

// Styling for the wrapper
const StyledContentWrapper = styled("div")(({ theme }) => ({
  zIndex: 1,
  position: "relative",
}));

export default function Home() {
  const images = [
    "https://dev.medias3.digi-sim-api.co.uk/virtus-tech/images/daf85de3-1bf8-429d-bde4-768bf2fbc183.png",
    "https://dev.medias3.digi-sim-api.co.uk/virtus-tech/images/d2d6db74-6836-4347-bb20-625ae0825e50.png",
    "https://dev.medias3.digi-sim-api.co.uk/virtus-tech/images/c4fe66db-7e14-4122-ac1d-6833100db2eb.png",
  ];
  const [bgLoaded, setBgLoaded] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [fadeState, setFadeState] = useState<"fade-in" | "fade-out">("fade-in");

  const [demo, setDemo] = useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState("fade-out");
      setTimeout(() => {
        setCurrentImage((prev) => (prev + 1) % images.length);
        setBgLoaded(false);
        setFadeState("fade-in");
      }, 1200); // match fade duration
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (localStorage.getItem("inactivityRedirectEnabled") === "true") {
      setDemo(true);
    } else {
      setDemo(false);
    }
  }, []);

  // useSelector allows you to access the data from the slice
  const { id, config } = useSelector((state: IRootState) => state.ConfigSlice);

  useEffect(() => {
    // Sending request to get data
    dispatch(getConfig());
  }, []);

  useEffect(() => {
    // If data is available start loading images
    if (id !== "") {
      getImages(config, dispatch);
    }
  }, [id]);

  return (
    <>
      {demo && (
        <div
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            height: "20px",
            width: "20px",
            backgroundColor: "#f26920",
            zIndex: 2000,
            borderRadius: "50%",
            // border: "3px solid red"
          }}
        />
      )}
      <StyledBackgroundVideoWrapper>
        {/* <AppVideoPlayer video={vid} autoPlay={true} loop={true} /> */}
        <img
          src={images[currentImage]}
          style={{
            height: "100vh",
            width: "100vw",
            objectFit: "cover",
            zIndex: "0",
            position: "absolute",
            opacity: bgLoaded && fadeState === "fade-in" ? 1 : 0,
            transition: "opacity 2.5s ease",
          }}
          onLoad={() => setBgLoaded(true)}
        />
      </StyledBackgroundVideoWrapper>

      <StyledContentWrapper>
        <Greeting />
      </StyledContentWrapper>
    </>
  );
}
